var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-google-translate',{attrs:{"defaultLanguageCode":_vm.store.config.language,"fetchBrowserLanguage":false,"languages":_vm.languages},on:{"select":_vm.googleTranslateSelectedHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }